import { render, staticRenderFns } from "./sales-view.vue?vue&type=template&id=478c7e3e&scoped=true"
import script from "./sales-view.vue?vue&type=script&lang=ts"
export * from "./sales-view.vue?vue&type=script&lang=ts"
import style0 from "./sales-view.vue?vue&type=style&index=0&id=478c7e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c7e3e",
  null
  
)

export default component.exports